export default [
  // checks router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Paiements",
      layout: "dashboard",
    },
    path: "/checks",
    name: "checks",
    component: () => import("@/layouts/index/CheckIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Chèques clients",
          layout: "dashboard",
        },
        path: "customers/index",
        name: "checks-customers-index",
        component: () => import("@/views/checks/customers/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Creer un chèque de clients",
          layout: "dashboard",
        },
        path: "customers/create",
        name: "checks-customers-create",
        component: () => import("@/views/checks/customers/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Chèques clients en attente",
          layout: "dashboard",
        },
        path: "customers/pending/index",
        name: "checks-customers-pending",
        component: () => import("@/views/checks/customers/Pending.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Chèques clients payes",
          layout: "dashboard",
        },
        path: "customers/paid/index",
        name: "checks-customers-paid",
        component: () => import("@/views/checks/customers/Paid.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Chèques clients impayes",
          layout: "dashboard",
        },
        path: "customers/unpaid/index",
        name: "checks-customers-unpaid",
        component: () => import("@/views/checks/customers/Unpaid.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Chèques clients remarquees",
          layout: "dashboard",
        },
        path: "customers/noticed/index",
        name: "checks-customers-noticed",
        component: () => import("@/views/checks/customers/Noticed.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Dètails chèque client",
          layout: "dashboard",
        },
        path: "customers/:reference/details",
        name: "checks-customers-details",
        component: () => import("@/views/checks/customers/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Dètails chèque fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/:reference/details",
        name: "checks-suppliers-details",
        component: () => import("@/views/checks/suppliers/Details.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Dètails chèque client",
          layout: "dashboard",
        },
        path: "customers/:reference/edit",
        name: "checks-customers-edit",
        component: () => import("@/views/checks/customers/Edit.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Chèques fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/index",
        name: "checks-suppliers-index",
        component: () => import("@/views/checks/suppliers/Listing.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Chèques fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/create",
        name: "checks-suppliers-create",
        component: () => import("@/views/checks/suppliers/Create.vue"),
      },
    ],
  },
];
